import { pathgen } from 'object-path-generator';
export function createLocaleProxy(t) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    return pathgen(undefined, function(path) {
        for(var _len = arguments.length, options = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            options[_key - 1] = arguments[_key];
        }
        const finalPath = path.split('.$value')[0];
        return t(finalPath, ...options);
    });
}
